export type SelectColorKey = 'green' | 'purple' | 'orange' | 'blue' | 'red' | 'yellow' | 'gray' | 'teal';

export interface SelectColorPalette {
  key: SelectColorKey;
  label: string;
  background: string;
  text: string;
}

export const WORKSHEET_SELECT_COLORS: SelectColorPalette[] = [
  { key: 'green', label: 'Green', background: '#E8F5E9', text: '#2E7D32' },
  { key: 'purple', label: 'Purple', background: '#F3E5F5', text: '#7B1FA2' },
  { key: 'orange', label: 'Orange', background: '#FFF3E0', text: '#EF6C00' },
  { key: 'blue', label: 'Blue', background: '#E3F2FD', text: '#1565C0' },
  { key: 'red', label: 'Red', background: '#FFEBEE', text: '#C62828' },
  { key: 'yellow', label: 'Yellow', background: '#FFFDE7', text: '#F9A825' },
  { key: 'gray', label: 'Gray', background: '#F5F5F5', text: '#616161' },
  { key: 'teal', label: 'Teal', background: '#E0F2F1', text: '#00796B' }
];

export const getSelectColor = (key?: string): SelectColorPalette => {
  return WORKSHEET_SELECT_COLORS.find((color) => color.key === key) || WORKSHEET_SELECT_COLORS[0];
};
